const BusinessFormDisclaimer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex w-[500px] flex-row items-center justify-start gap-2 rounded-[15px] bg-[#fffaeb] py-3.5 pl-5 pr-8">
      <InfoIcon size={30} />
      <p className="text-sm text-primary">{children}</p>
    </div>
  )
}

export default BusinessFormDisclaimer

const InfoIcon = ({ size = 30 }: { size?: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30" fill="none">
      <circle cx="15" cy="15" r="15" fill="white" />
      <circle cx="15" cy="15" r="15" fill="#FFC300" fillOpacity="0.25" />
      <path
        d="M15.2738 13.3594C15.9762 13.3594 16.5475 13.9286 16.5475 14.6331V19.7282C16.5475 20.4307 15.9783 21.002 15.2738 21.002C14.5714 21.002 14 20.4328 14 19.7282V14.6331C14 13.9286 14.5714 13.3594 15.2738 13.3594Z"
        fill="#FFC300"
      />
      <path
        d="M15.2738 12.5475C15.9773 12.5475 16.5475 11.9773 16.5475 11.2738C16.5475 10.5703 15.9773 10 15.2738 10C14.5703 10 14 10.5703 14 11.2738C14 11.9773 14.5703 12.5475 15.2738 12.5475Z"
        fill="#FFC300"
      />
    </svg>
  )
}
